<script setup lang="ts">

import { faAdd } from '@fortawesome/pro-regular-svg-icons'

import { RowSlot } from '@shared/ui/other'
import { LinkBreadcrumb } from '@shared/ui/menus'
import { BtnIcon } from '@shared/ui/buttons'

import { useKidDisciplines } from '../model/kid-disciplines.hook'

defineOptions({
  name: 'KidDisciplineLinks',
})

const {
  refDisciplines,
  isAllDisciplinesAdded,
  addDisciplineTooltip,
  getDisciplineName,
  getDisciplineUrl,
  openAddDiscipline,
} = useKidDisciplines()
</script>

<template>
  <RowSlot
    label="Discipline"
    class="kid-discipline-links"
  >
    <LinkBreadcrumb
      v-for="discipline in refDisciplines"
      :key="discipline.id"
      :text="getDisciplineName(discipline.code)"
      :to="getDisciplineUrl(discipline.id)"
    />
    <BtnIcon
      :tooltip-text="addDisciplineTooltip"
      :icon="faAdd"
      :disabled="isAllDisciplinesAdded"
      @click="openAddDiscipline"
    />
  </RowSlot>
</template>

<style scoped lang="scss" src="./KidDisciplineLinks.scss" />
